import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import firebase from 'firebase/app';
import { Http } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'page-view-broker',
  templateUrl: 'view-broker.html',
})
export class ViewBrokerPage {

  usersDetails : any;
  contact_uid: any;
  singleUserDetails: any;
  unique_key: any;
  public user_data;
  public brokerCredentials

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http : Http,
    public db: AngularFirestore
  ) {
    this.user_data = '';
    this.brokerCredentials = '';
    let thiss = this;
    this.contact_uid = this.navParams.get("contact_uid");
    if(this.contact_uid != undefined || this.contact_uid != ""){
      var docRef1 = firebase.firestore().collection("users").doc(thiss.contact_uid);
      docRef1.get().then(function(doc) {
        if (doc.exists) {
          thiss.user_data = doc.data();
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });

      var docRef2 = firebase.firestore().collection("brokerCredentials").doc(thiss.contact_uid);
      docRef2.get().then(function(doc) {
        if (doc.exists) {
          thiss.brokerCredentials = doc.data();
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewContactPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-broker/view-broker.ts